import { defineStore } from "pinia";
import vc from "vue-cookies";
import { layoutStore } from "./layout";


export const authStore = defineStore("auth", {
    state: () => {
        const auth = vc.get("auth");
        if (auth) {
            return auth;
        }

        return {
            loginType: "",
            appToken: "",
            appTokenUgems: "",
            appTokenInsting: "",
            config: undefined,
            rememberMe: false,
            appData: undefined,
            isafeNo: "",
        };
    },

    actions: {
        setUgems(userAuth){
            const state = this;
            state.appTokenUgems = userAuth.appToken;
            this.setCookie("auth", this.state);
        },
        set(userAuth) {
            const state = this;
            state.appToken = userAuth.appToken;
            state.appTokenInsting = userAuth.appTokenInsting;
            state.appData = userAuth.appData;
            state.appDataInsting = userAuth.appDataInsting;
            state.rememberMe = userAuth.rememberMe;
            state.access = userAuth.access;
            this.setCookie("auth", this.state);
        },
        updateJwt(jwt) {
            this.appToken = jwt.tokenEsb;
            this.appData = jwt.profile;
            this.rememberMe = jwt.rememberMe;
            // this.config = jwt.config;
            this.setCookie("auth", this.state);
        },
        updateJwtInsting(jwt) {
            this.appTokenInsting = jwt.appTokenInsting
            this.setCookie("authInsting", this.state);
        },
        updateJwtUgems(jwt) {
            this.appTokenUgems = jwt.access_token;
            this.setCookie("authUgems", this.state);
        },
        setLoginType(loginType) {
            const state = this;
            state.loginType = loginType;
            this.setCookie("auth", this.state);
        },
        // setActivate(activated) {
        //     const state = this;
        //     state.activated = activated;
        //     this.setCookie("auth", this.state);
        // },
        clear() {
            // const layout = layoutStore()
            // layout.menus = [];

            const state = this;
            state.loginType = "";
            state.appToken = "";
            state.appTokenUgems = "";
            state.appTokenInsting = "";
            state.config = undefined;
            state.appData = undefined;
            state.appDataSimper = undefined;
            state.appDataInsting = [];
            state.rememberMe = false;
            vc.remove("auth", "/");
            vc.remove("authUgems", "/");
            vc.remove("authInsting", "/");
            this.setCookie("auth", this.state);
            this.setCookie("authUgems", this.state);
            this.setCookie("authInsting", this.state);
        },
        setCookie(key, value) {
            if(value.rememberMe){
                vc.set(key, value, "7d");    
            }else{
                vc.set(key, value, "1d");    
            }
        },
    },

    getters: {
        state(state) {
            const res = {};
            [
                "loginType",
                "appData",
                "appDataSimper",
                "appToken",
                "appTokenUgems",
                "appTokenInsting",
                "config",
                "rememberMe",
            ].forEach((e) => {
                res[e] = state[e];
            });

            return res;
        },
    },
});
